import styled from '@emotion/styled'
import {
  TextArea as InformedTextArea,
  FormValue,
  FieldProps,
  FormValues,
} from 'informed'
import React from 'react'

import { overrideOptional } from '@emico/overrides'
import { maxWidth } from '@emico/styles'

export type TextAreaProps = Omit<
  FieldProps<FormValue, FormValues>,
  'type' | 'checked'
> &
  Pick<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'cols' | 'rows'>

const TextAreaInput = (props: TextAreaProps) => <InformedTextArea {...props} />

export const StyledTextAreaInput = styled(TextAreaInput)`
  @media ${maxWidth('sm')} {
    font-size: 16px;
  }
`

const TextArea = ({ ...props }: TextAreaProps) => (
  <StyledTextAreaInput {...props} />
)

export default overrideOptional(TextArea)
